import { render, staticRenderFns } from "./PlannedVacancies.vue?vue&type=template&id=02060c8d&scoped=true&"
import script from "./PlannedVacancies.vue?vue&type=script&lang=js&"
export * from "./PlannedVacancies.vue?vue&type=script&lang=js&"
import style0 from "./PlannedVacancies.vue?vue&type=style&index=0&id=02060c8d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02060c8d",
  null
  
)

component.options.__file = "PlannedVacancies.vue"
export default component.exports